import stbAPIGateway from '../../../../services/stbAPIGateway';

export const getCsvTenants = async ({ rootGetters }, { clientSid }) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);

  const tenants = await stbApi.getHubCsvTenants(clientSid);
  return tenants;
};
